import type { EventBusKey } from "@vueuse/core"
import { useEventBus } from "@vueuse/core"

const eventKey: EventBusKey<number | undefined> = Symbol("eventKey")

export const AlbumIdEventBus = useEventBus<number | undefined>(eventKey)

/**
 * Emit the current album id to update the Navbar title
 * @param albumId - The id of the current album
 */
export function emitSelectedAlbum(albumId: number | undefined): void {
  AlbumIdEventBus.emit(albumId)
}
